import faker from 'faker';

import { CONTRACT_DEFAULT_GRACE_PERIOD } from '../contract.constants';
import { IContract, IContractData } from '../contract.types';
import { Contract } from '../contract';
import { createRange } from '@/utils/helpers';
import { mockCurrenciesData } from '@/models/currency';
import { createRandomContractItem } from './contract-item.mock';

export function createRandomContract(): IContractData {
  return {
    id: faker.datatype.number(),
    quote: faker.datatype.number(),
    grace_period_days: faker.datatype.number({
      min: CONTRACT_DEFAULT_GRACE_PERIOD,
      max: CONTRACT_DEFAULT_GRACE_PERIOD * 1.5
    }),
    currency: faker.random.arrayElement(mockCurrenciesData()),
    csi_order_number: faker.datatype.string(),
    customer_account_number: faker.datatype.string(),
    payment_term: faker.datatype.number(),
    total_value: faker.datatype.number(),

    items: createRange(4).map(() => createRandomContractItem())
  };
}

export const mockContractsData: IContractData[] = createRange(5).map(() =>
  createRandomContract()
);

export const mockContracts = (
  data: IContractData[] = mockContractsData
): IContract[] => data.map(item => new Contract(item));
